import { UserSubscriptionPlanEnum } from "~/solidJs/shared/helpers/types";

export enum TariffBtnModeEnum {
	Upgrade = "upgrade",
	Downgrade = "downgrade",
	Current = "current"
}
type tariffLokUpType = Partial<{
	[key in UserSubscriptionPlanEnum]: Partial<{
		[key in UserSubscriptionPlanEnum]: TariffBtnModeEnum;
	}>;
}>;
export const tariffLokUp: tariffLokUpType = {
	[UserSubscriptionPlanEnum.Free]: {
		[UserSubscriptionPlanEnum.Free]: TariffBtnModeEnum.Current,
		[UserSubscriptionPlanEnum.Starter]: TariffBtnModeEnum.Upgrade,
		[UserSubscriptionPlanEnum.Pro]: TariffBtnModeEnum.Upgrade,
		[UserSubscriptionPlanEnum.Teams]: TariffBtnModeEnum.Upgrade,
		[UserSubscriptionPlanEnum.Enterprise]: TariffBtnModeEnum.Upgrade
	},
	[UserSubscriptionPlanEnum.Starter]: {
		[UserSubscriptionPlanEnum.Free]: TariffBtnModeEnum.Downgrade,
		[UserSubscriptionPlanEnum.Starter]: TariffBtnModeEnum.Current,
		[UserSubscriptionPlanEnum.Pro]: TariffBtnModeEnum.Upgrade,
		[UserSubscriptionPlanEnum.Teams]: TariffBtnModeEnum.Upgrade,
		[UserSubscriptionPlanEnum.Enterprise]: TariffBtnModeEnum.Upgrade
	},
	[UserSubscriptionPlanEnum.Pro]: {
		[UserSubscriptionPlanEnum.Free]: TariffBtnModeEnum.Downgrade,
		[UserSubscriptionPlanEnum.Starter]: TariffBtnModeEnum.Downgrade,
		[UserSubscriptionPlanEnum.Pro]: TariffBtnModeEnum.Current,
		[UserSubscriptionPlanEnum.Teams]: TariffBtnModeEnum.Upgrade,
		[UserSubscriptionPlanEnum.Enterprise]: TariffBtnModeEnum.Upgrade
	},
	[UserSubscriptionPlanEnum.Teams]: {
		[UserSubscriptionPlanEnum.Free]: TariffBtnModeEnum.Downgrade,
		[UserSubscriptionPlanEnum.Starter]: TariffBtnModeEnum.Downgrade,
		[UserSubscriptionPlanEnum.Pro]: TariffBtnModeEnum.Downgrade,
		[UserSubscriptionPlanEnum.Teams]: TariffBtnModeEnum.Current,
		[UserSubscriptionPlanEnum.Enterprise]: TariffBtnModeEnum.Upgrade
	},
	[UserSubscriptionPlanEnum.Enterprise]: {
		[UserSubscriptionPlanEnum.Free]: TariffBtnModeEnum.Downgrade,
		[UserSubscriptionPlanEnum.Starter]: TariffBtnModeEnum.Downgrade,
		[UserSubscriptionPlanEnum.Pro]: TariffBtnModeEnum.Downgrade,
		[UserSubscriptionPlanEnum.Teams]: TariffBtnModeEnum.Downgrade,
		[UserSubscriptionPlanEnum.Enterprise]: TariffBtnModeEnum.Current
	},
	[UserSubscriptionPlanEnum.Legacy_Freemium]: {
		[UserSubscriptionPlanEnum.Legacy_Freemium]: TariffBtnModeEnum.Current,
		[UserSubscriptionPlanEnum.Legacy_Advanced]: TariffBtnModeEnum.Upgrade,
		[UserSubscriptionPlanEnum.Legacy_Premium]: TariffBtnModeEnum.Upgrade,
		[UserSubscriptionPlanEnum.Legacy_Plus]: TariffBtnModeEnum.Upgrade,
		[UserSubscriptionPlanEnum.Free]: TariffBtnModeEnum.Upgrade,
		[UserSubscriptionPlanEnum.Starter]: TariffBtnModeEnum.Upgrade,
		[UserSubscriptionPlanEnum.Pro]: TariffBtnModeEnum.Upgrade,
		[UserSubscriptionPlanEnum.Teams]: TariffBtnModeEnum.Upgrade,
		[UserSubscriptionPlanEnum.Enterprise]: TariffBtnModeEnum.Upgrade
	},
	[UserSubscriptionPlanEnum.Legacy_Trialing]: {
		[UserSubscriptionPlanEnum.Legacy_Freemium]: TariffBtnModeEnum.Current,
		[UserSubscriptionPlanEnum.Legacy_Advanced]: TariffBtnModeEnum.Upgrade,
		[UserSubscriptionPlanEnum.Legacy_Premium]: TariffBtnModeEnum.Upgrade,
		[UserSubscriptionPlanEnum.Legacy_Plus]: TariffBtnModeEnum.Upgrade,
		[UserSubscriptionPlanEnum.Free]: TariffBtnModeEnum.Upgrade,
		[UserSubscriptionPlanEnum.Starter]: TariffBtnModeEnum.Upgrade,
		[UserSubscriptionPlanEnum.Pro]: TariffBtnModeEnum.Upgrade,
		[UserSubscriptionPlanEnum.Teams]: TariffBtnModeEnum.Upgrade,
		[UserSubscriptionPlanEnum.Enterprise]: TariffBtnModeEnum.Upgrade
	},
	[UserSubscriptionPlanEnum.Legacy_Advanced]: {
		[UserSubscriptionPlanEnum.Legacy_Freemium]: TariffBtnModeEnum.Downgrade,
		[UserSubscriptionPlanEnum.Legacy_Advanced]: TariffBtnModeEnum.Current,
		[UserSubscriptionPlanEnum.Legacy_Premium]: TariffBtnModeEnum.Upgrade,
		[UserSubscriptionPlanEnum.Legacy_Plus]: TariffBtnModeEnum.Upgrade,
		[UserSubscriptionPlanEnum.Free]: TariffBtnModeEnum.Upgrade,
		[UserSubscriptionPlanEnum.Starter]: TariffBtnModeEnum.Upgrade,
		[UserSubscriptionPlanEnum.Pro]: TariffBtnModeEnum.Upgrade,
		[UserSubscriptionPlanEnum.Teams]: TariffBtnModeEnum.Upgrade,
		[UserSubscriptionPlanEnum.Enterprise]: TariffBtnModeEnum.Upgrade
	},
	[UserSubscriptionPlanEnum.Legacy_Premium]: {
		[UserSubscriptionPlanEnum.Legacy_Freemium]: TariffBtnModeEnum.Downgrade,
		[UserSubscriptionPlanEnum.Legacy_Advanced]: TariffBtnModeEnum.Downgrade,
		[UserSubscriptionPlanEnum.Legacy_Premium]: TariffBtnModeEnum.Current,
		[UserSubscriptionPlanEnum.Legacy_Plus]: TariffBtnModeEnum.Upgrade,
		[UserSubscriptionPlanEnum.Free]: TariffBtnModeEnum.Upgrade,
		[UserSubscriptionPlanEnum.Starter]: TariffBtnModeEnum.Upgrade,
		[UserSubscriptionPlanEnum.Pro]: TariffBtnModeEnum.Upgrade,
		[UserSubscriptionPlanEnum.Teams]: TariffBtnModeEnum.Upgrade,
		[UserSubscriptionPlanEnum.Enterprise]: TariffBtnModeEnum.Upgrade
	},
	[UserSubscriptionPlanEnum.Legacy_Plus]: {
		[UserSubscriptionPlanEnum.Legacy_Freemium]: TariffBtnModeEnum.Downgrade,
		[UserSubscriptionPlanEnum.Legacy_Advanced]: TariffBtnModeEnum.Downgrade,
		[UserSubscriptionPlanEnum.Legacy_Premium]: TariffBtnModeEnum.Downgrade,
		[UserSubscriptionPlanEnum.Legacy_Plus]: TariffBtnModeEnum.Current,
		[UserSubscriptionPlanEnum.Free]: TariffBtnModeEnum.Upgrade,
		[UserSubscriptionPlanEnum.Starter]: TariffBtnModeEnum.Upgrade,
		[UserSubscriptionPlanEnum.Pro]: TariffBtnModeEnum.Upgrade,
		[UserSubscriptionPlanEnum.Teams]: TariffBtnModeEnum.Upgrade,
		[UserSubscriptionPlanEnum.Enterprise]: TariffBtnModeEnum.Upgrade
	},
	[UserSubscriptionPlanEnum.Legacy_PlusMax]: {
		[UserSubscriptionPlanEnum.Free]: TariffBtnModeEnum.Upgrade,
		[UserSubscriptionPlanEnum.Starter]: TariffBtnModeEnum.Upgrade,
		[UserSubscriptionPlanEnum.Pro]: TariffBtnModeEnum.Upgrade,
		[UserSubscriptionPlanEnum.Teams]: TariffBtnModeEnum.Upgrade,
		[UserSubscriptionPlanEnum.Enterprise]: TariffBtnModeEnum.Upgrade
	},
	[UserSubscriptionPlanEnum.Superuser]: {
		[UserSubscriptionPlanEnum.Legacy_Freemium]: TariffBtnModeEnum.Downgrade,
		[UserSubscriptionPlanEnum.Legacy_Advanced]: TariffBtnModeEnum.Downgrade,
		[UserSubscriptionPlanEnum.Legacy_Premium]: TariffBtnModeEnum.Downgrade,
		[UserSubscriptionPlanEnum.Legacy_Plus]: TariffBtnModeEnum.Downgrade,
		[UserSubscriptionPlanEnum.Free]: TariffBtnModeEnum.Downgrade,
		[UserSubscriptionPlanEnum.Starter]: TariffBtnModeEnum.Downgrade,
		[UserSubscriptionPlanEnum.Pro]: TariffBtnModeEnum.Downgrade,
		[UserSubscriptionPlanEnum.Teams]: TariffBtnModeEnum.Downgrade,
		[UserSubscriptionPlanEnum.Enterprise]: TariffBtnModeEnum.Downgrade
	}
};
